<div class="modal-header">
  <h4 class="modal-title" [ngClass]="{ 'limit-modal-title': limit_modal_title }">
    {{ modal_title }}
  </h4>

  <button
    type="button"
    class="btn btn-close btn-sm"
    aria-label="Close"
    (click)="dismissModal()"
  ></button>
</div>

<div class="modal-body" [ngClass]="{ 'normalize-external-styles': normalize_external_styles }">
  <span [innerHTML]="modal_body | domSanitizer"></span>
</div>
